function getPlugins() {
  if (!navigator.plugins) return [];

  return Array.from(navigator.plugins).map((p) => p.name);
}

async function getFonts() {
  const baseFonts = ['monospace', 'sans-serif', 'serif'];
  const testFonts = ['Arial', 'Verdana', 'Times New Roman', 'Courier New', 'Georgia'];

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const defaultWidth = {};
  baseFonts.forEach((font) => {
    ctx.font = `72px ${font}`;
    defaultWidth[font] = ctx.measureText('mmmmmmmmmm').width;
  });

  return testFonts.filter((font) =>
    baseFonts.some((base) => {
      ctx.font = `72px '${font}',${base}`;
      return ctx.measureText('mmmmmmmmmm').width !== defaultWidth[base];
    })
  );
}

function getCanvasHash() {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  ctx.textBaseline = 'top';
  ctx.font = "14px 'Arial'";
  ctx.fillStyle = '#f60';
  ctx.fillRect(125, 1, 62, 20);
  ctx.fillStyle = '#069';
  ctx.fillText('fingerprint', 2, 15);

  return hashString(canvas.toDataURL());
}

function getWebGLHash() {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

    if (!gl) return null;

    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
    const vendor = debugInfo ? gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) : '';
    const renderer = debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : '';

    return hashString(`${vendor}~${renderer}`);
  } catch {
    return null;
  }
}

async function getAudioHash() {
  try {
    const context = new (window.AudioContext || window.webkitAudioContext)();

    const oscillator = context.createOscillator();
    const analyser = context.createAnalyser();
    const gain = context.createGain();

    oscillator.type = 'triangle';
    oscillator.frequency.value = 10000;

    gain.gain.value = 0;

    oscillator.connect(analyser);
    analyser.connect(gain);
    gain.connect(context.destination);

    oscillator.start(0);
    const data = new Float32Array(analyser.frequencyBinCount);
    analyser.getFloatFrequencyData(data);

    oscillator.stop();

    return hashString(data.join(''));
  } catch {
    return null;
  }
}

function hashString(str) {
  let hash = 0;
  if (!str) return null;

  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }

  return hash.toString();
}

export async function getFingerprint() {
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    screen: {
      width: window.screen.width,
      height: window.screen.height,
      pixelRatio: window.devicePixelRatio || 1,
    },

    hardwareConcurrency: navigator.hardwareConcurrency || null,
    deviceMemory: navigator.deviceMemory || 0,
    touchSupport: 'ontouchstart' in window || navigator.maxTouchPoints > 0,

    plugins: getPlugins(),
    fonts: await getFonts(),

    canvasHash: getCanvasHash(),
    webglHash: getWebGLHash(),
    audioHash: await getAudioHash(),
  };
}
